/**
 * Line Setup Configuration
 * Used for setting up LINE Messaging API credentials
 */

export const getLineSetupConfig = (projectId: string, taskId: string | null) => ({
    id: 'line-setup',
    step_title: 'ตั้งค่า Line',
    step_description: 'ตั้งค่า LINE Messaging API สำหรับเชื่อมต่อกับช่องทางแชท',
    agent_interactive: false,
    config: JSON.stringify({
        // Pre-fill from GET /api/credentials/<project_id>/{deploy_id}
        prefetch_url: `${process.env.NEXT_PUBLIC_CREDENTIAL_API_URL}/api/credentials/${projectId}/${taskId}`,
        prefetch_method: 'GET',
        requests: {
            type: 'object',
            required: ['line_channel_secret', 'line_channel_access_token'],
            properties: {
                line_channel_secret: {
                    type: 'string',
                    label: 'LINE Channel Secret',
                    user_input: true,
                    placeholder: 'ใส่ LINE Channel Secret ของคุณ'
                },
                line_channel_access_token: {
                    type: 'string',
                    label: 'LINE Channel Access Token',
                    user_input: true,
                    placeholder: 'ใส่ LINE Channel Access Token ของคุณ'
                }
            }
        },
        // Save to PUT /api/credentials/<project_id>/{deploy_id}
        endpoint_url: `${process.env.NEXT_PUBLIC_CREDENTIAL_API_URL}/api/credentials/${projectId}/${taskId}`,
        endpoint_method: 'PUT'
    })
});
